import { AssetsMessageIcon, ChatRoundIcon, CountDownIcon, UserMessageIcon } from '@/components/icon';
import { GoalType } from '@/interface';

export const enum SelectType {
  userMessageGoal = 'userMessageGoal',
  assistantMessageGoal = 'assistantMessageGoal',
  chatRound = 'chatRound',
  sceneIntimacyGoal = 'sceneIntimacyGoal',
  countDown = 'countDown',
  numSysGoal = 'numSysGoal',
}

export interface IOption {
  type: SelectType,
  value: GoalType,
  label: string,
  render: 'string' | 'number' | 'object' | 'switch',
  uiOptions?: { min?: number, max?: number }
  switchGroupKey?: string;
  cantChoose?: boolean;
  icon?: JSX.Element;
}

export const goalCnameMap: { [key: number]: string } = {
  [GoalType.GOAL_TYPE_DEFAULT]: '默认',
  [GoalType.GOAL_TYPE_ASSISTANT_MESSAGE]: '角色发言',
  [GoalType.GOAL_TYPE_USER_MESSAGE]: '玩家发言',
  [GoalType.GOAL_TYPE_CHAT_ROUND]: '对话轮数触发',
  [GoalType.GOAL_TYPE_NUM_SYS]: '数值触发',
  [GoalType.GOAL_TYPE_COUNTDOWN]: '倒计时触发',
};

export const defaultOptions: IOption[] = [
  {
    label: goalCnameMap[GoalType.GOAL_TYPE_USER_MESSAGE],
    type: SelectType.userMessageGoal,
    value: GoalType.GOAL_TYPE_USER_MESSAGE,
    render: 'string',
    icon: <UserMessageIcon />,
  },
  {
    label: goalCnameMap[GoalType.GOAL_TYPE_ASSISTANT_MESSAGE],
    type: SelectType.assistantMessageGoal,
    value: GoalType.GOAL_TYPE_ASSISTANT_MESSAGE,
    render: 'string',
    icon: <AssetsMessageIcon />,
  },
  {
    label: goalCnameMap[GoalType.GOAL_TYPE_CHAT_ROUND],
    type: SelectType.chatRound,
    value: GoalType.GOAL_TYPE_CHAT_ROUND,
    render: 'number',
    uiOptions: {
      min: 0,
    },
    icon: <ChatRoundIcon />,
  },
  {
    label: goalCnameMap[GoalType.GOAL_TYPE_NUM_SYS],
    type: SelectType.numSysGoal,
    value: GoalType.GOAL_TYPE_NUM_SYS,
    render: 'object',
    switchGroupKey: 'numSys',
    icon: <ChatRoundIcon />,
  },
  {
    label: goalCnameMap[GoalType.GOAL_TYPE_COUNTDOWN],
    type: SelectType.countDown,
    value: GoalType.GOAL_TYPE_COUNTDOWN,
    render: 'switch',
    switchGroupKey: 'countDown',
    uiOptions: {
      min: -100,
      max: 100,
    },
    icon: <CountDownIcon />,
  },
];
